import $ from 'jquery';


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$(function() {

  //読み込む動画のidをここにセット
  let ytData = [
    {
      id: 'mYzWshrGXtA',
      area: 'yt_0'
    },
    {
      id: 'BIzxAbX9K1g',
      area: 'yt_1'
    }
  ];

  var ytPlayer = [];


  // 各エリアにプレーヤーを埋め込む
  window.onYouTubeIframeAPIReady = function() {
    for (var i = 0; i < ytData.length; i++) {
      ytPlayer[i] = new YT.Player(ytData[i]['area'], {
        height: '450',
        width: '800',
        videoId: ytData[i]['id'],
        playerVars: {
          'rel': 0
        }
      });
    }
  }

  var current_video = '',
      $movie = '';
  //再生
  var video_play = function($elm) {
      current_video = $elm.data('video');
      ytPlayer[current_video].playVideo();
  }

  //停止
  var video_stop = function() {
      ytPlayer[current_video].stopVideo();
  }

  //動画用モーダル開く
  var video_modal_open = function($elm) {
    $movie = $('.js-md-Modal__itemPlayer').eq($elm.data('video'));
    $movie.show();
    $('.js-md-Modal').addClass('is-show');
  }

  //動画用モーダル閉じる
  var video_modal_close = function() {
    $('.js-md-Modal').removeClass('is-show');
    $movie.hide();
  }

  $('.js-cm-Gallery__item').on('click', function () {
    video_modal_open($(this));
    video_play($(this));
  });

  $('.js-md-Modal__itemClose').on('click', function () {
    video_modal_close();
    video_stop();
  });
});

